<template>
<div class="map" style="background-image: url('/ru/lg-travel/images/desktop/map/bg.png')">
  <Stages :content="content.map.stages" />
<!--  <div class="map-title">-->
<!--    {{ content.map.title}}-->
<!--  </div>-->
  <Footer :content="content.footer" />
  <div class="container map-container" >
    <div class="map-overlay" id="map">
      <gmap-map
          :center="mapStyle.center"
          :zoom="11"
          :options="mapStyle"
          ref="mapRef"
          style="height: 100%;width: 100%"
      >
        <div v-if="$browserDetect.isIE">
        <gmap-marker
            :key="index"
            v-for="(m, index) in markers"
            :position="m.position"
            @click="zoomMe(m)"
          >
        </gmap-marker>
        <gmap-marker
            v-if="userLocation"
            :position="userLocation"
        >
        </gmap-marker>
        </div>
        <div v-else>
          <gmap-marker
              :key="index"
              v-for="(m, index) in markers"
              :position="m.position"
              :icon="{ url: '/ru/lg-travel/images/desktop/map/marker.svg'}"
              @click="zoomMe(m)"
          >
          </gmap-marker>
          <gmap-marker
              v-if="userLocation"
              :position="userLocation"
              :icon="{ url: '/ru/lg-travel/images/desktop/map/user_marker.svg'}"
          >
          </gmap-marker>
        </div>
      </gmap-map>
    </div>
    <div class="map-title">

    </div>
    <div class="map__image"></div>
  </div>
  </div>
</template>

<script>
import Stages from "../stages/Stages";
import {mapStyles} from "../../style/mapStyle";
import {mapState} from 'vuex'
import {bus} from "../../utils/bus";
import Footer from "../footer/Footer";
export default {
  props: ['content'],
  components: {Stages,Footer},
  name: "Map",
  data(){
    return{
      mapStyle: {
        zoom: 4,
        center: {lat: 36.91606637812379 , lng: 32.59167005675609},
        styles: mapStyles
      }
    }
  },
  computed: {
    ...mapState({
      userLocation: 'userLocation',
      selectedCountry: "selectedCountry"
    }),
    markers() {
      const data  = []
      this.content.hero.slides.forEach(item => data.push(item))
      return data
    }
  },
  methods: {
    zoomMe(item){
      this.$refs.mapRef.$mapPromise.then((map) => {
          map.setZoom(6)
          map.setCenter(item.position);
          this.$store.commit('SET_SELECTED_COUNTRY',item.country)
      })
    }
  },
  mounted() {
    bus.$on('scroll-to-map', (item) => {
      this.zoomMe(item)
    });
  }
}
</script>

<style scoped lang="scss">
@import "map.scss";
</style>